// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const RequestPropertyValue = {
    query: (value) => {
        return Object.assign(Object.assign({}, value), { type: "query", _visit: function (visitor) {
                return FernIr.RequestPropertyValue._visit(this, visitor);
            } });
    },
    body: (value) => {
        return Object.assign(Object.assign({}, value), { type: "body", _visit: function (visitor) {
                return FernIr.RequestPropertyValue._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "query":
                return visitor.query(value);
            case "body":
                return visitor.body(value);
            default:
                return visitor._other(value);
        }
    },
};
